<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>
<style lang="scss">
    @import "./styles/main";
</style>
<script>
  export default {
    name: "App",
    components: {},
    created() {
    },
    methods: {
    },
  }
</script>
